<template>
    <div class="match">
      <!-- <RadioGroup v-model="button1" type="button">
        <Radio label="智能分区"></Radio>
        <Radio label="智能排班"></Radio>
      </RadioGroup> -->
      <div class="work-day" v-show="show">{{levelData}}</div>
      <Select style="width:200px"@on-change="choiceUser">
          <Option v-for="item in cityList" :value="item.value"  :key="item.value">{{ item.label }}</Option>
      </Select>
      <DatePicker type="date" @on-change="handleChange" placeholder="请选择日期" style="width: 200px"></DatePicker>
      <i-switch v-model="show" @on-change="switchChange"></i-switch>
      <div v-show="show" class="work-day">工作天数：{{workDay}}</div>
      <div v-show="show" class="work-day">点数：{{pointCount}}</div>
      <div v-show="!show" class="all-point" v-html="allPoint"></div>

      <div v-show="show" class='map-control'>
        <div id="mapContainer">我是地图</div>
      </div>
      <!-- <iframe  v-show="!show" class='map-control' frameBorder='0' src='https://www.dituwuyou.com/map/Fivkt7BGLF8FeY1JlG-UPg/embed?base_map=normal&center=116.403874%2C39.914889&level=12'> </iframe> -->
      <!-- <iframe v-show="!show" class='map-control' frameBorder='0' src='https://www.dituwuyou.com/map/NqqwuE_UDxjTaHTiGT_KtA/embed?base_map=normal&center=116.538364%2C39.92527&level=11'> </iframe> -->
      <iframe  class='map-control' frameBorder='0' src='https://www.dituwuyou.com/map/P-OJM0mH_6XuIz0yJLirfQ/embed?base_map=normal&center=116.286439%2C39.900362&level=11'> </iframe>
    </div>
</template>
<script>
import getData from "../service/getData";
import api from "../service/api";
import getColor from "../service/randomColor.js";
import moment from "moment";

let osmurl =
  // "https://webrd04.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}";
  "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetGray/MapServer/tile/{z}/{y}/{x}";
export default {
  data: function() {
    return {
      msg: "软素",
      show: true,
      workDay: 0,
      pointCount: 0,
      levelData: "",
      allPoint: `区域0:1369.23 区域1:1364.24 区域2:1365.92 区域3:1363.67 区域4:1353.39 区域5:1373.37 区域6:1361.99 区域7:1360.36 区域8:1351.95 区域9:1361.43
      <br/> 区域10:1367.65 区域11:1348.37 区域12:1372.42 区域13:1359.45 区域14:1361.70 区域15:1363.35 区域16:1353.35 区域17:1338.75 区域18:1340.39`,
      layerGroup: new L.layerGroup([]),
      cityList: [
        {
          value: "region0",
          label: "人员0"
        },
        {
          value: "region1",
          label: "人员1"
        },
        {
          value: "region2",
          label: "人员2"
        },
        {
          value: "region3",
          label: "人员3"
        },
        {
          value: "region4",
          label: "人员4"
        },
        {
          value: "region5",
          label: "人员5"
        },
        {
          value: "region6",
          label: "人员6"
        },
        {
          value: "region7",
          label: "人员7"
        },
        {
          value: "region8",
          label: "人员8"
        },
        {
          value: "region9",
          label: "人员9"
        },
        {
          value: "region10",
          label: "人员10"
        },
        {
          value: "region11",
          label: "人员11"
        },
        {
          value: "region12",
          label: "人员12"
        },
        {
          value: "region13",
          label: "人员13"
        },
        {
          value: "region14",
          label: "人员14"
        },
        {
          value: "region15",
          label: "人员15"
        },
        {
          value: "region16",
          label: "人员16"
        },
        {
          value: "region17",
          label: "人员17"
        },
        {
          value: "region18",
          label: "人员18"
        }
      ],
      selectDate: "",
      selectUser: null,
      pointsAll: {},
      lineMap: new Map(), //每一条线路的信息
      colorMap: new Map(), //用来保存一个人一个月的颜色
      dateMap: new Map(), //用来保存日期和数组对应(i,2018-09-01)
      layerMap: new Map() //用来存储每一天的数据
    };
  },
  mounted() {
    //初始化地图
    this.map = L.map("mapContainer", {
      center: [39.908701, 116.397481],
      zoom: 10,
      minZoom: 1,
      maxZoom: 18,
      projection: L.Projection.LonLat,
      attributionControl: false,
      zoomControl: false
    });
    L.tileLayer(osmurl).addTo(this.map);
    L.control
      .zoom({
        position: "bottomright",
        zoomInTitle: "放大",
        zoomOutTitle: "缩小"
      })
      .addTo(this.map);
    L.control
      .scale({
        imperial: false
      })
      .addTo(this.map);
    this.layerGroup.addTo(this.map);
    this.getParams();
  },
  methods: {
    getParams: async function(region) {
      const res = await getData.get(api.softium0, {
        region: region ? region : "region0"
      });
      if (res.data && res.data.status) {
        this.pointsAll = res.data.info.points_all;
        let level1 = 0;
        let level2 = 0;
        let level3 = 0;
        let level4 = 0;
        for (let pointKey in this.pointsAll) {
          if (this.pointsAll[pointKey].level === "1") {
            level1 += 1;
          } else if (this.pointsAll[pointKey].level === "2") {
            level2 += 1;
          } else if (this.pointsAll[pointKey].level === "3") {
            level3 += 1;
          } else if (this.pointsAll[pointKey].level === "4") {
            level4 += 1;
          }
        }
        this.levelData =
          "等级1：" +
          level1 +
          "等级2：" +
          level2 +
          "等级3：" +
          level3 +
          "等级4：" +
          level4;

        this.pointCount = Object.keys(this.pointsAll).length;
        this.lineMap = new Map();
        let startDay = moment("2018-11-01", "YYYY-MM-DD");
        for (let i = 0; i < res.data.info.line_info.length; i++) {
          while (startDay.day() === 0 || startDay.day() === 6) {
            startDay = startDay.add(1, "d");
          }
          const linInfo = res.data.info.line_info[i];
          this.lineMap.set(startDay.format("YYYY-MM-DD"), linInfo);
          this.dateMap.set(i, startDay.format("YYYY-MM-DD"));
          startDay = startDay.add(1, "d");
        }
        this.drawAllData();
      }
    },
    handleChange(date) {
      this.selectDate = date;
      const that = this;
      for (let layersGroup of this.layerMap.values()) {
        layersGroup.remove();
      }
      if (this.selectDate === "") {
        for (let layersGroup of this.layerMap.values()) {
          layersGroup.addTo(this.map);
        }
      } else {
        this.layerMap.get(this.selectDate).addTo(this.map);
      }
    },
    switchChange(status) {
      this.show = status;
    },
    choiceUser(user) {
      this.selectUser = user;
      console.log("人员是：" + this.selectUser);
      for (let layersGroup of this.layerMap.values()) {
        layersGroup.remove();
      }
      this.layerMap.clear();
      console.log("输出");
      this.getParams(this.selectUser);
    },
    drawAllData() {
      const durction_map = { "1": 30, "2": 25, "3": 25, "4": 15 };
      const times_map = { "1": 4, "2": 3, "3": 2, "4": 1 };
      const vevehicle_map = { "1": "步行", "2": "公交", "3": "驾车" };
      //画全部的信息
      this.workDay = this.lineMap.size;
      for (let [key, value] of this.lineMap) {
        const color = getColor.getColor();
        const layers = [];

        for (let i = 0; i < value.point_ids.length; i++) {
          const pointId = value.point_ids[i];
          const route = value.route_info[i];
          const point = this.pointsAll[pointId];
          const divHtml = `<div class='way-points' style='background-color:${color}'>${i +
            1}</div>`;
          const wayDivIcon = new L.divIcon({
            html: divHtml,
            className: "leaflet-direction-icon"
          });
          let stayTime = durction_map[point.level];
          let times = times_map[point.level];
          let dateString = [];
          for (let item of point.dates) {
            dateString.push(this.dateMap.get(item));
          }
          dateString = dateString.join(";");

          const attrMarker = [];
          attrMarker.push("名称：" + point.ORGNAME);
          attrMarker.push("等级：" + point.level);
          attrMarker.push("访问频次：" + times);
          attrMarker.push("访问时间：" + dateString);
          attrMarker.push("预计到达：" + route.time);
          attrMarker.push("停留时间：" + stayTime + "分钟");

          layers.push(
            L.marker([point.Latitude, point.Longitude], {
              icon: wayDivIcon
              // draggable: true
            }).bindPopup(attrMarker.join("<br>"))
          );
          //***************画线***************/
          if (route.distance != 0) {
            let vehicle = "";
            if (typeof route.vehicle_type === "number") {
              vehicle = vevehicle_map[route.vehicle_type + ""];
            } else {
              vehicle =
                vevehicle_map[route.vehicle_type[0] + ""] +
                ":" +
                route.vehicle_type[1];
            }

            const attrRoute = [];
            attrRoute.push("走访日期：" + key);
            attrRoute.push("走访总里程：" + value.distance);
            attrRoute.push("拜访客户数：" + value.point_ids.length);
            attrRoute.push("分段里程：" + route.distance + "米");
            attrRoute.push("通勤方式：" + vehicle);

            const latLngs = [];
            const routes = route.path.split(";");
            for (let route of routes) {
              latLngs.push(route.split(",").reverse());
            }
            layers.push(
              L.polyline(latLngs, {
                color: color
              }).bindPopup(attrRoute.join("<br>"))
            );
          }
        }
        const layerGroup = L.layerGroup(layers);
        layerGroup.addTo(this.map);
        this.layerMap.set(key, layerGroup);
      }
    }
  }
};
</script>
<style lang="less">
.match {
  width: 100%;
  height: 100%;
}
.map-control {
  width: 100%;
  height: calc(~"100% - 36px");
}
.all-point {
  display: inline-block;
  vertical-align: top;
}
.work-day {
  display: inline;
}
#mapContainer {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Softium0.vue